export default __webpack_public_path__ + "static/media/Jets.79546ff7.png";